var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M18,9.2l-7,7c-0.2,0.2-0.4,0.3-0.7,0.3 s-0.5-0.1-0.7-0.3L6,12.7c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l2.8,2.8l6.3-6.3c0.4-0.4,1-0.4,1.4,0C18.3,8.2,18.3,8.8,18,9.2z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18,9.2l-7,7c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3L6,12.7c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0 l2.8,2.8l6.3-6.3c0.4-0.4,1-0.4,1.4,0C18.3,8.2,18.3,8.8,18,9.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18,9.2l-7,7c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3L6,12.7c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0 l2.8,2.8l6.3-6.3c0.4-0.4,1-0.4,1.4,0C18.3,8.2,18.3,8.8,18,9.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.52eff8dc.svg";
export { ForwardRef as ReactComponent };